export default Object.freeze({
  Subscription: 1,
  CreditPurchase: 2,
  AIRecharge: 3,
  ProfessionalServices: 4,
  Marketplace: 5,
  WhatsAppConsumption: 6,
  SMSConsumption: 7,
  VoiceConsumption: 8,
  Storage: 9,
  Other: 99,
});
